<app-header></app-header>
@defer (on viewport) {
  <app-best-package [momentProducts]="momentProductsList"></app-best-package>
} @placeholder {
  <div style="min-height: 120vh; width: 100%;"></div>
}
@defer (on viewport) {
  <app-why-choose-youprice></app-why-choose-youprice>
} @placeholder {
  <div style="min-height: 300px; width: 100%;"></div>
}
@defer (on viewport; prefetch on idle) {
  <app-review></app-review>
} @placeholder {
  <div style="min-height: 400px; width: 100%;"></div>
}
@defer (on viewport) {
  <app-small-faq></app-small-faq>
  <app-footer></app-footer>
} @placeholder {
  <div style="min-height: 400px; width: 100%;"></div>
}